import { useCallback, useEffect } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { integrationsActions } from '@store/integrations/integrations.slice';

import { RouteEnum } from '@enum/route.enum';
import { StepEnum } from '@enum/step.enum';
import { useCurrentApplicationParams } from '@hook/application/use-current-application-params.hook';
import { usePrevious } from '@hook/common/use-previous.hook';
import { useQuery } from '@hook/common/use-query.hook';
import { useStep } from '@hook/common/use-step.hook';
import { useLoadIntegrationsQuery } from '@hook/intergration/integration.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist, isString } from '@util/data/is-exist';

export const useApplicationSetupConnectorsPage = () => {
  const navigate = useNavigate();
  const { onChange, step } = useStep();
  const { current } = useCurrentApplicationParams();
  const prevStep = usePrevious(step);

  useQuery(
    useLoadIntegrationsQuery(current?.id ?? '', { skip: !isString(current?.id), refetchOnMountOrArgChange: true }),
    integrationsActions,
    integrationsActions.setData,
  );

  const { data, isLoading } = useStoreSelector((state) => state.connectors);

  const onNext = useCallback(() => {
    if (isExist(current)) {
      if ([StepEnum.Connectors, StepEnum.Consumer].includes(step))
        return navigate(generatePath(RouteEnum.ApplicationSetupConsumer.path, { applicationId: current.id }), {
          replace: true,
        });
      else onChange(StepEnum.Connectors);
    }
  }, [current, navigate, step]);

  useEffect(() => {
    if (prevStep === StepEnum.ApplicationName && step === StepEnum.Connectors)
      navigate(generatePath(RouteEnum.ApplicationSetupConsumer.path, { applicationId: current.id }), { replace: true });
  }, [prevStep, step]);

  return {
    data: Object.values(data),
    isLoading,
    onNext,
  };
};
